import { makeStyles } from '@material-ui/core';
export default makeStyles((theme) => ({
  mainHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '3em',
    paddingTop: 30,
    alignItems: 'center',
    '@media (max-width: 525px)': {
      marginBottom: 0,
      paddingTop: 0,
    },
  },
  mainHeaderBtns: {
    display: 'flex',
    alignItems: 'center',
  },
  mainHeaderText: {
    fontSize: 29,
    letterSpacing: 0.3,
    color: theme.palette.warning.contrastText,
    fontWeight: 700,
    '@media (max-width: 525px)': {
      fontSize: 20,
    },
  },
  investNowButton: {
    height: 48,
    width: 200,
    background: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: 8,
    fontSize: 18,
    fontWeight: 600,
    cursor: 'pointer',
    textTransform: 'capitalize',
    '&:hover': {
      background: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
  },
  copyUrlBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: 20,
  },
  copyUrlText: {
    fontSize: 16,
    letterSpacing: 0.3,
    color: theme.palette.grey[50],
    fontWeight: 800,
    textAlign: 'end',
    cursor: 'pointer',
  },
  copyUrlIcon: {
    height: 20,
    width: 20,
    marginRight: 8,
    textAlign: 'end',
    cursor: 'pointer',
  },
  referContainer: {
    background: theme.palette.common.white,
    borderRadius: '11px',
    boxShadow: theme.shadows[3],
    padding: '20px 40px',
    '@media (max-width: 525px)': {
      padding: '15px 25px',
    },
  },
  referFriendText: {
    fontSize: 18,
    letterSpacing: 0.3,
    color: theme.palette.error.contrastText,
    fontWeight: 700,
    lineHeight: '45px',
    textAlign: 'center',
    marginBottom: 15,
    '@media (max-width: 525px)': {
      lineHeight: '25px',
    },
  },
  investDFullBox: {
    boxShadow: theme.shadows[4],
    borderRadius: 11,
    background: theme.palette.primary.contrastText,
    padding: '31px 33px 39px',
    marginBottom: 24,
    '@media (max-width: 525px)': {
      padding: '20px',
    },
    textAlign: 'center',
  },
  investDBox: {
    display: 'flex',
    marginBottom: 25,
    '@media (max-width: 767px)': {
      display: 'block',
    },
  },
  invstTable: {
    boxShadow: theme.shadows[4],
    borderRadius: 11,
    background: theme.palette.primary.contrastText,
    padding: '1.5em',
    // marginBottom: 24,
    width: 600,
    '@media (min-width: 1700px)': {
      width: '60%',
    },
    '@media (max-width: 767px)': {
      width: 'auto',
      marginBottom: 25,
    },
    '@media (max-width: 525px)': {
      padding: '20px',
    },
  },
  invstTText: {
    fontSize: 16,
    color: theme.palette.grey[500],
    marginBottom: 22,
    '@media (max-width: 525px)': {
      fontSize: 16,
    },
  },
  invstTSText: {
    fontSize: 20,
    color: theme.palette.grey[500],
    textTransform: 'uppercase',
    marginBottom: 22,
    fontWeight: 400,
    '@media (max-width: 525px)': {
      fontSize: 16,
    },
  },
  table: {},
  invstTh: {
    fontWeight: 600,
    width: 300,
    fontFamily: theme.typography.fontFamily,
    color: '#262A41 !important',
    '@media (max-width: 1200px)': {
      width: 150,
    },
  },
  invstHunt: {
    width: 420,
    marginLeft: 16,
    boxShadow: theme.shadows[4],
    borderRadius: 11,
    background: theme.palette.primary.contrastText,
    padding: '1.5em',
    '@media (min-width: 1700px)': {
      width: '40%',
    },
    '@media (max-width: 767px)': {
      width: 'auto',
      marginLeft: 0,
    },
  },
  adobeIconImg: {
    width: '24px',
    height: '24px',
  },
  invstHuntBox: {
    padding: '1em',
    boxShadow: theme.shadows[3],
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1.5em',
  },
  invstHuntBoxLeft: {
    width: '4.5em',
    height: '4.5em',
    background: '#FFDFC3',
    marginRight: '1em',
    borderRadius: '1em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  invstHHtext: {
    fontWeight: 400,
    fontSize: 14,
    margin: 0,
    lineHeight: '1.2',
    marginBottom: '.5em',
  },
  invstHSText: {
    color: theme.palette.secondary.main,
    fontSize: 14,
    fontWeight: 600,
  },
  // popup styling --------------
  investPopUp: {
    padding: '30px 20px',
    '& .MuiBackdrop-root': {
      background: theme.palette.primary.main,
    },
    '& .MuiDialog-paperFullWidth': {
      padding: 0,
      width: '100%',
      maxHeight: '100%',
      height: '100%',
      margin: 0,
      '@media (max-width: 767px)': {
        borderRadius: 0,
      },
    },
    '& .MuiDialog-paperWidthLg': {
      maxWidth: '100%',
    },
    '& .MuiTypography-h5': {
      top: 25,
      right: 25,
      zIndex: 1,
    },
    '& .MuiDialogContent-root': {
      padding: 0,
      overflowY: 'hidden',
      height: '100%',
    },
    '& .MuiTypography-h6': {
      padding: 0,
    },
    '@media (max-width: 767px)': {
      padding: '0px',
    },
  },
  // popup styling End ----------
  loader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  errorMessage: {
    fontSize: 15,
    letterSpacing: 0.35,
    color: theme.palette.error.main,
  },
}));
